import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

export function FileSheetDialog({ sheetId, onClose, onDone }) {
  const [plans, setPlans] = useState([]);
  const [val, setVal] = useState("");
  useEffect(() => { api.get("/console/plans").then(({ data }) => setPlans(data.plans || [])).catch(() => setPlans([])); }, []);
  const go = async () => {
    try { await api.post(`/console/sheets/${sheetId}/file`, { plan_id: val }); toast.success("Sheet filed into plan"); onDone(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="bg-white border-[#EEEFEF] max-w-md" data-testid="file-sheet-dialog">
        <DialogHeader><DialogTitle className="font-display">File into a plan</DialogTitle><DialogDescription className="text-[#9FA1A4]">The sheet gets the plan's item ID and AI agents for that brand will use it.</DialogDescription></DialogHeader>
        <select data-testid="file-sheet-plan" value={val} onChange={(e) => setVal(e.target.value)} className="w-full h-10 rounded-md bg-[#F6F6FD] border border-[#EEEFEF] px-2.5 text-sm">
          <option value="">Pick a plan…</option>
          {plans.map((p) => <option key={p.id} value={p.id}>{p.code} · {p.name} ({p.client_name}{p.brand_name ? ` · ${p.brand_name}` : ""})</option>)}
        </select>
        <DialogFooter><Button variant="outline" onClick={onClose} className="rounded-full border-[#EEEFEF]">Cancel</Button><Button data-testid="file-sheet-confirm" disabled={!val} onClick={go} className="rounded-full bg-[#06060C] text-white hover:bg-[#1c1c24]">File sheet</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
